import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * ReceiptDivider
 */
export const receiptDividerStyles = ({ theme, $withHorizontalSpacing, }) => css `
	margin: 0;
	height: 0;
	border-top: ${theme.borderWidth['2']}px solid ${theme.colors.medium.dividerReceipt};

	${$withHorizontalSpacing &&
    css `
		margin: 0 ${pxToRem(theme.spacing['400'])};

		@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
			margin: 0 ${pxToRem(theme.spacing['500'])};
		}
	`}
`;
export const StyledReceiptDivider = styled.hr `
	${receiptDividerStyles}
`;
